<template>
    <div>
        <div v-if="postSuccessful !== null" class="messages-container my-5">
            <div v-if="! messages.length && ! postSuccessful">
                <div class="alert alert-danger">
                    Er is een onbekende fout opgetreden. Probeer het opnieuw of neem contact met ons op.
                </div>
            </div>

            <div v-for="message in messages"
                 :class='{"alert": true, "alert-success": postSuccessful, "alert-danger": ! postSuccessful}'>
                {{ message }}
            </div>
        </div>

        <form @submit.prevent="validateForm" ref="form" v-if="postSuccessful !== true">
            <div v-if="! isCreate" class="row">
                <h5>Soort pas</h5>
            </div>
            <div class="row"  v-if="! isCreate" >
                <div class="col-12 col-sm-9 p-0">
                    <label>{{ cardType  }}</label>
                </div>
            </div>

            <div class="row p-h5">
                <h5>Welke opties wilt u activeren?</h5>
            </div>

            <div class="row mb-3">
                <div class="col-10">
                    <div class="row">
                        <div class="col" v-for="(tank_card_option ,parent ) in tank_card_options"
                             v-if="canShowOptions(parent)">
                            <div class="row">
                                <div v-if="tank_card_option.showSwitch" class="custom-control custom-switch">
                                    <input type="checkbox" v-model="tank_card_option.value"
                                           class="custom-control-input custom-control-input-red"
                                           :id="parent"/>
                                    <label class="custom-control-label" :for="parent">{{
                                            tank_card_option.title
                                        }}</label>

                                    <i v-if="tank_card_option.popover[parent]" class="fas fa-info-circle pl-2 pt-1 text-info" data-container="body"
                                        data-toggle="popover"
                                       data-placement="right" data-trigger="hover"
                                       :data-content="tank_card_option.popover[parent]"></i>
                                </div>
                                <div v-else>
                                    <label>{{ tank_card_option.title }}</label>
                                </div>
                            </div>
                            <div v-if="tank_card_option.description">{{ tank_card_option.description }}</div>
                            <div v-if="tank_card_option.value" :id="parent" class="pt-3">
                                <div   v-for="(value ,option ) in tank_card_option.options"
                                    class="row custom-control custom-switch mb-3">
                                    <div class="col">
                                        <tankcard-option-switch
                                            :optionValue="tank_card_options[parent].options[option]"
                                            :optionKey="option"
                                            :title="titles[option]"
                                            :adjustmentsFieldsDisabled="adjustmentsFields.includes(option)"
                                            :parent="parent"
                                            @updateOption="updateOption"
                                            :popoverText="tank_card_option.popover[option]"
                                        >

                                        </tankcard-option-switch>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row pt-4 mt-4">
                <h3>Uw gegevens </h3>
            </div>

            <div class="pb-4 pt-3">
                <div class="row">
                    <label
                        for="license_plate">Kenteken</label>
                    <i class="fas fa-info-circle pl-2 pt-1 text-info" data-container="body" data-toggle="popover"
                       data-placement="right" data-trigger="hover"
                       data-content="Maximaal 8 tekens"></i>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-9 p-0">
                        <input id="license_plate" type="text" class="form-control"
                               :class='{"border border-warning": adjustmentsFields.includes("license_plate")}'
                               :readonly="adjustmentsFields.includes('license_plate')"
                               v-model="license_plate"
                               maxlength="8">
                    </div>
                </div>
            </div>
            <div class="pb-4 pt-3" v-if="isCreate">
                <div class="row">
                    Pincode (4 cijfers) <span class="text-red">&nbsp;&nbsp;*</span>
                </div>

                <div class="row">
                    <div class="col-4 col-sm-2 p-0">
                        <input id="form" type="number" class="form-control" pattern="[0-9]{4}" maxlength="4"
                               required="required" min="1" max="9999" v-model="pin"
                               >
                    </div>
                </div>
            </div>


            <div class="pb-4">
                <div class="row">
                    <label for="car_info">Auto info </label>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-9 p-0">
                        <input id="car_info" type="text"
                               v-model="car_info"
                               :readonly="adjustmentsFields.includes('car_info')"
                               :class='{"border border-warning": adjustmentsFields.includes("car_info")}'
                               class="form-control">
                    </div>
                </div>
            </div>

            <div class="pb-4">
                <div class="row">
                    <label for="car_info">Extra info</label>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-9 p-0">
                        <input id="extra_info" type="text"
                               v-model="extra_info"
                               maxlength="50"
                               :readonly="adjustmentsFields.includes('extra_info')"
                               :class='{"border border-warning": adjustmentsFields.includes("extra_info")}'
                               class="form-control">
                    </div>
                </div>
            </div>

            <div>
                <div class="pb-4">
                    <div class="row">
                        <label>Daglimiet (in Euro) <span class="text-red">&nbsp;&nbsp;*</span></label>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-9 p-0">
                            <select
                                v-model="euro_daily_limit"
                                required
                                :class='{"border border-warning": adjustmentsFields.includes("euro_daily_limit")}'
                                :disabled="adjustmentsFields.includes('euro_daily_limit')"
                                class="form-control "
                            >
                                <option v-for="option in euroDailyLimit"
                                        :value="option"
                                        :disabled=" euro_week_limit !== 0 && option > euro_week_limit">{{ option }}
                                </option>
                            </select>

                        </div>
                    </div>
                </div>

                <div class="pb-4">
                    <div class="row">
                        <label>Weeklimiet (in Euro) <span class="text-red">&nbsp;&nbsp;*</span></label>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-9 p-0">
                            <select
                                v-model="euro_week_limit"
                                required
                                :class='{"border border-warning": adjustmentsFields.includes("euro_week_limit")}'
                                :disabled="adjustmentsFields.includes('euro_week_limit')"
                                class="form-control "
                            >
                                <option v-for="option in euroWeekLimit" :value="option"
                                        :disabled=" euro_daily_limit !== 0 && option < euro_daily_limit">{{ option }}
                                </option>
                            </select>

                        </div>
                    </div>
                </div>

                <div class="pb-4">
                    <div class="row">
                        <label>Daglimiet aantal <span class="text-red">&nbsp;&nbsp;*</span></label>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-9 p-0">
                            <select
                                v-model="amount_daily_limit"
                                required
                                :class='{"border border-warning": adjustmentsFields.includes("amount_daily_limit")}'
                                :disabled="adjustmentsFields.includes('amount_daily_limit')"
                                class="form-control "
                            >
                                <option v-for="option in amountDailyLimit"
                                        :value="option"
                                        :disabled="amount_week_limit  !== 0 && option > amount_week_limit">{{ option }}
                                </option>
                            </select>

                        </div>
                    </div>
                </div>

                <div class="pb-4">
                    <div class="row">
                        <label>Weeklimiet aantal<span class="text-red">&nbsp;&nbsp;*</span> </label>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-9 p-0">
                            <select
                                v-model="amount_week_limit"
                                required
                                :class='{"border border-warning": adjustmentsFields.includes("amount_week_limit")}'
                                :disabled="adjustmentsFields.includes('amount_week_limit')"
                                class="form-control "
                            >
                                <option v-for="option in amountWeekLimit"
                                        :value="option"
                                        :disabled="amount_daily_limit  !== 0 && option < amount_daily_limit">{{ option }}
                                </option>
                            </select>

                        </div>
                    </div>
                </div>
            </div>

            <div class="row pt-4 pb-2">
                <h3>Ondertekening</h3>
            </div>

            <div class="pb-3">
                <div class="row">
                    <label for="signature_name">Naam aanvrager <span class="text-red">&nbsp;&nbsp;*</span></label>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-9 p-0">
                        <input id="signature_name" type="text" class="form-control" v-model="signature_name" required>
                    </div>
                </div>
            </div>

            <div class="row custom-control custom-checkbox mb-3">
                <input type="checkbox" class="custom-control-input" v-model="signature"
                       id="signature" value="signature" required>
                <label class="custom-control-label pl-2 "
                       for="signature">
                    Ik ga akkoord met de
                    <a :href="conditionsUrl" target="_blank" class="text-red">algemene voorwaarden</a>.
                    U ontvangt een e-mail ter bevestiging van uw aanvraag.
                </label>
            </div>

            <div class="form-group  row pt-5 mt-2">

                <div class=" col-auto p-0">
                    <a :href="backUrl" class="btn btn-white">
                        <i class="avia-icons-arrow-right"></i>
                        Terug
                    </a>
                </div>

                <div class="col-auto col-auto ml-1 pl-3">
                    <button type="submit" :disabled='isLoading' class="btn btn-red m-0">
                        <span v-if="isCreate">AVIA Card aanvragen</span> <span v-else >AVIA Card wijzigen</span>
                        <i class="avia-icons-arrow-left"></i>
                    </button>
                </div>

                <div v-if="isLoading" class="col-auto  js-loading-container">
                    <div class="la-ball-clip-rotate js-loading la-2x"><div></div></div>
                </div>

            </div>

            <div class="modal fade" id="payAttention" tabindex="-1" role="dialog" aria-labelledby="payAttentionLabel"
                 ref="modal"
                 aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="payAttentionLabel">Let op!</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div v-if="attentionCharging" class="modal-body">
                            U kunt dit niet aanpassen op bestaande {{ cardType }},
                            <a :href="createCardUrl"  class="text-red">vraag een nieuwe AVIA Card aan</a>.
                        </div>
                        <div v-else class="modal-body">
                            U kunt dit niet aanpassen op een bestaande pas. Er wordt een nieuwe pas naar u opgestuurd.
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Sluiten</button>
                        </div>

                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        tankCard: Object,
        adjustmentsFields: {
            type: Array,
            default: () => []
        },
        euroDailyLimit: Array,
        euroWeekLimit: Array,
        amountDailyLimit: Array,
        amountWeekLimit: Array,
        backUrl: {
            default: '',
            type: String
        },
        tankCardsActionUrl: String,
        isCreate: {
            default: false,
            type: Boolean
        },
    },
    data: function () {
        return {
            signature: false,
            isLoading: false,
            attentionCharging: false,
            conditionsUrl: route('information.conditions'),
            createCardUrl: route('tank_cards.create'),
            tankCardsUrl: route('tank_cards.index'),

            tankCardsActionCompeteUrl: route(this.tankCardsActionUrl, [this.tankCard['id'] ?? null]),
            signature_name: '',
            cardType: this.tankCard['card_type'] == 'AVIA VO VODO' ? 'Tankkaart' :( this.tankCard['card_type'] ==
            'AVIA CARD' ? 'AVIA Card' : 'Truckkaart' ),
            tank_card_type: this.tankCard.card_type || 'AVIA CARD',
            tank_card_options: {
                'fuel': {
                    'showSwitch': true,
                    'value': this.tankCard.visual_tank_card_option['fuel']['value'],
                    'title': 'Tanken',
                    'description': '',
                    'options': {
                        'benzine': this.tankCard.visual_tank_card_option['fuel']['options']['benzine'],
                        'diesel': this.tankCard.visual_tank_card_option['fuel']['options']['diesel'],
                        'ecosave': this.tankCard.visual_tank_card_option['fuel']['options']['ecosave'],
                        'lpg': this.tankCard.visual_tank_card_option['fuel']['options']['lpg'],
                        'autocode': this.tankCard.visual_tank_card_option['fuel']['options']['autocode'],
                        'km': this.tankCard.visual_tank_card_option['fuel']['options']['km'],
                        'international': this.tankCard.visual_tank_card_option['fuel']['options']['international'],
                    },
                    'popover': {
                        'benzine': 'Onder deze groep vallen de volgende producten: Euro 95, Super 98, Super Clean, V-Power, BP Ultimate benzine',
                        'diesel': 'Onder deze groep vallen de volgende producten: Diesel, V-Power, BP Ultimate Diesel, Ecosave, HVO, AdBlue',
                    }
                },
                'charging': {
                    'showSwitch': true,
                    'value': this.tankCard.visual_tank_card_option['charging']['value'],
                    'title': 'Laden',
                    'description': 'Let op: voor elektrisch laden wordt een abonnement afgesloten en worden er maandelijks kosten in rekening gebracht.',
                    'popover': {
                        'charging': 'Bij het activeren van het product laden dient u rekening te houden met een verwerkingstijd van 24 uur.',
                    }

                },
                'other': {
                    'showSwitch': false,
                    'value': true,
                    'title': 'Overig',
                    'description': '',
                    'options': {
                        'oil': this.tankCard.visual_tank_card_option['other']['options']['oil'],
                        'wash': this.tankCard.visual_tank_card_option['other']['options']['wash'],
                        'shop': this.tankCard.visual_tank_card_option['other']['options']['shop'],
                    },
                    'popover': {}
                }
            },
            titles: {
                'oil': 'Olie producten',
                'wash': 'Carwash',
                'shop': 'Shop',
                'benzine': 'Benzine',
                'diesel': 'Diesel',
                'ecosave': 'Ecosave',
                'lpg': 'LPG',
                'autocode': 'Autocode',
                'km': 'KM Registratie',
                'international': 'Internationaal',
            },
            payAttention: {
                'km': true,
                'autocode': true,
                'charging': true
            },
            euro_daily_limit: this.tankCard.visual_tank_card_option['fuel']['limits']['euro_daily_limit'],
            euro_week_limit: this.tankCard.visual_tank_card_option['fuel']['limits']['euro_week_limit'],
            amount_daily_limit: this.tankCard.visual_tank_card_option['fuel']['limits']['amount_daily_limit'],
            amount_week_limit: this.tankCard.visual_tank_card_option['fuel']['limits']['amount_week_limit'],
            license_plate: this.tankCard['license_plate'],
            car_info: this.tankCard['car_info'],
            pin: null,
            extra_info: this.tankCard['extra_info'],
            messages: [],
            postSuccessful: null,
        };
    },
    watch: {
        'tank_card_options': {
            handler() {
                this.$nextTick(
                    () => $('[data-toggle="popover"]').popover()
                )
            },
            deep: true
        },
        'tank_card_options.charging.value': function (value) {

            if(value && this.tankCard['card_type'] !== 'AVIA CARD' && ! this.isCreate){
                this.attentionCharging = true;
                $('#payAttention').modal('show');
                this.$nextTick(() => {
                    this.tank_card_options.charging.value = false;
                })
            }

        }
    },
    mounted() {
        $('[data-toggle="popover"]').popover()
    },
    methods: {
        canShowOptions(parent){
            // when type card not truck card and  in create page don't show charging
            return (! (this.tank_card_type === 'ATRUCK VO VODO' && this.isCreate)) || parent !=='charging'
        },
        tankCardsData() {
            return {
                'card_type': this.tank_card_type,
                'pin': this.pin,
                'euro_daily_limit': this.euro_daily_limit,
                'euro_week_limit': this.euro_week_limit,
                'amount_daily_limit': this.amount_daily_limit,
                'amount_week_limit': this.amount_week_limit,
                'signature_name': this.signature_name,
                'signature': this.signature,
                'license_plate': this.license_plate,
                'car_info': this.car_info,
                'extra_info': this.extra_info,
                'tank_card_option': {
                    'fuel': this.tank_card_options.fuel['value'],
                    'charging': (this.tank_card_type !== 'ATRUCK VO VODO' ) ?
                    this.tank_card_options.charging['value'] : false,
                    'benzine': this.tank_card_options.fuel.options['benzine'],
                    'diesel': this.tank_card_options.fuel.options['diesel'],
                    'ecosave': this.tank_card_options.fuel.options['ecosave'],
                    'lpg': this.tank_card_options.fuel.options['lpg'],
                    'autocode': this.tank_card_options.fuel.options['autocode'],
                    'km': this.tank_card_options.fuel.options['km'],
                    'international': this.tank_card_options.fuel.options['international'],
                    'oil': this.tank_card_options.other.options['oil'],
                    'shop': this.tank_card_options.other.options['shop'],
                    'wash': this.tank_card_options.other.options['wash'],
                },

            };
        },
        validateForm(e) {
            this.isLoading = true
            axios.post(this.tankCardsActionCompeteUrl, this.tankCardsData())
                .then((response) => {
                    this.isLoading = false
                    // location.reload(true);
                    this.messages = response.data.messages || []
                    this.postSuccessful = response.data.success || false
                    window.scrollTo(0, 0);
                    //   this.lapMutationsPerBrand = response.data.lap_mutations || []
                })
                .catch((error) => {
                    this.isLoading = false
                    this.messages = [error.response.data.message];
                    this.postSuccessful = false;
                    window.scrollTo(0, 0);
                })
        },
        updateOption(option) {
            if (this.payAttention[option.value] && option.checked  && ! this.isCreate) {
                this.attentionCharging = false;
                $('#payAttention').modal('show');
            }
            this.tank_card_options[option.parent].options[option.value] = option.checked;
        }
    }

}
</script>
<!--<style lang="scss" scoped>-->
<!--input[type=checkbox].custom-control-input ~ .custom-control-label.border-warning::before {-->
<!--    background-color: #E10000 !important;-->
<!--}-->
<!--</style>-->
